"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = exports.setCookie = void 0;

var setCookie = function setCookie(name, value, expiration) {
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var d = new Date();
  d.setTime(d.getTime() + expiration);
  document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(d.toUTCString(), ";path=").concat(path);
};

exports.setCookie = setCookie;

var getCookie = function getCookie(name) {
  var dCookie = decodeURIComponent(document.cookie);
  var cookies = dCookie.split(';');

  for (var i = 0; i < cookies.length; i++) {
    var cp = cookies[i].trim().split('=');
    if (cp[0] === name) return cp[1];
  }

  return null;
};

exports.getCookie = getCookie;